import MeetingsStore from "./Meetings/MeetingsStore";
import InternalMeetingsStore from "./InternalMeetings/InternalMeetingsStore";
import MeetingDetailStore from "./MeetingDetail/MeetingDetailStore";
import ReviewQueueStore from "./ReviewQueue/ReviewQueueStore";
import ReadAiSettingsStore from "./Settings/ReadAiSettingsStore";
import PartnersStore from "./Partners/PartnersStore";
import PartnerDetailStore from "./PartnerDetail/PartnerDetailStore";
import DomainMappingsStore from "./DomainMappings/DomainMappingsStore";
import MeetingSourcesStore from "./MeetingSources/MeetingSourcesStore";
import DeliveryConnectionsStore from "./DeliveryConnections/DeliveryConnectionsStore";
import MappingQueueStore from "./MappingQueue/MappingQueueStore";
import AnalysisQueueStore from "./AnalysisQueue/AnalysisQueueStore";
import RoutingIssuesStore from "./RoutingIssues/RoutingIssuesStore";
import AssignmentDetailStore from "./AssignmentDetail/AssignmentDetailStore";
import MeetingReviewStore from "./MeetingDetail/MeetingReviewStore";
import MeetingRecapStore from "./MeetingDetail/MeetingRecapStore";
import MeetingRecordingStore from "./MeetingDetail/MeetingRecordingStore";
import MeetingInquiryStore from "./MeetingDetail/MeetingInquiryStore";

const meetingIntelligenceStoreList = [
  { name: "readAiMeetingsViewStore", store: MeetingsStore },
  { name: "internalMeetingsStore", store: InternalMeetingsStore },
  { name: "readAiMeetingDetailStore", store: MeetingDetailStore },
  { name: "reviewQueueStore", store: ReviewQueueStore },
  { name: "readAiSettingsViewStore", store: ReadAiSettingsStore },
  { name: "partnersAdminStore", store: PartnersStore },
  { name: "partnerDetailStore", store: PartnerDetailStore },
  { name: "domainMappingsStore", store: DomainMappingsStore },
  { name: "meetingSourcesStore", store: MeetingSourcesStore },
  { name: "deliveryConnectionsAdminStore", store: DeliveryConnectionsStore },
  { name: "mappingQueueStore", store: MappingQueueStore },
  { name: "analysisQueueStore", store: AnalysisQueueStore },
  { name: "routingIssuesStore", store: RoutingIssuesStore },
  // The Action Item screen every action-item notification links to.
  { name: "assignmentDetailStore", store: AssignmentDetailStore },
  // Meeting Detail → Review (the meeting review, plan/2026-10-21_FROM-GIRDER_meeting-review-and-cards.md §2).
  // NOT `meetingReviewsStore`: that is the `meeting-reviews` ServiceStore's key.
  { name: "meetingReviewStore", store: MeetingReviewStore },
  // Meeting Detail → Recap (#3182). NOT `meetingRecapsStore`: that is the
  // `meeting-recaps` ServiceStore's key.
  { name: "meetingRecapStore", store: MeetingRecapStore },
  // Meeting Detail → the Recording card (#2614): holds a short-lived signed link only.
  { name: "meetingRecordingStore", store: MeetingRecordingStore },
  // Meeting Detail → Client questions (#4211). NOT `meetingInquiryDraftsStore`:
  // that is the `meeting-inquiry-drafts` ServiceStore's key.
  { name: "meetingInquiryStore", store: MeetingInquiryStore },
];

export default meetingIntelligenceStoreList;
